export const toCommaNumber = (value: number | null | undefined) => {
  const numbers = (+(value || 0) || 0).toString().split('').reverse();

  const max = numbers.length;
  let count = 0;

  const result: string[] = [];

  for (let i = 0; i < max; i += 1) {
    count += 1;
    result.push(numbers[i]);

    if (count === 3) {
      result.push(',');
      count = 0;
    }
  }

  result.reverse();

  if (result[0] === ',') {
    result.shift();
  }

  return result.join('');
};
